import { FC, useMemo } from "react";
import currency from "currency.js";
import TableDetails from "./TableDetails";
import {
  IDetailsLoan,
  IDetailsLoanSecurityMappings,
  IDetailsSecurity,
} from "../models/report";
import { securityBuilderUI } from "../lib/builder";

const SecurityDetails: FC<{
  title: string;
  security: IDetailsSecurity;
  loans: IDetailsLoan[];
  loanSecurityMapping: IDetailsLoanSecurityMappings[];
}> = ({ title, security, loans, loanSecurityMapping }) => {
  const loanList = useMemo(() => {
    if (!security) return [];

    if (loanSecurityMapping?.length === 0) {
      return loans;
    }

    const _list = (loans || []).filter((_loan) => {
      return (
        !!(loanSecurityMapping || []).find(
          (_i) =>
            _i.loanId === _loan.loanId &&
            _i.securityId === security?.securityId,
        )?.loanId || false
      );
    });

    return _list;
  }, [security, loans, loanSecurityMapping]);

  const TotalLoanAmount = loanList.reduce(
    (acc, loan) =>
      acc +
      (loan?.loanType === "Existing" &&
      loan?.lendingAction === "None" &&
      (loan?.liability?.isRevolvingCredit === false ||
        loan?.liability?.isRevolvingCredit === null)
        ? loan?.liability?.balance || 0
        : loan?.loanType === "Existing" && loan?.lendingAction === "TopUp"
        ? (!isNaN(loan?.loanAmount)
            ? loan?.loanAmount
            : loan?.liability?.limit || 0) +
          (!isNaN(loan?.topUpAmount) ? loan?.topUpAmount : 0)
        : loan?.loanType === "New"
        ? loan?.loanAmount
        : !isNaN(loan?.loanAmount)
        ? loan?.loanAmount
        : loan?.liability?.limit || 0),
    0,
  );
  const DepositAmount = security.value - TotalLoanAmount;
  const hasNegativeDeposit = DepositAmount < 0;
  let LVR = (TotalLoanAmount / security.value) * 100;
  if (LVR % 1 !== 0) {
    LVR = parseFloat(LVR.toFixed(2));
  }

  return (
    <TableDetails
      title={title}
      data={securityBuilderUI(security)}
      noSpaceBottom={true}
      addSpaceTop={true}
      isSecurityDetails={true}
      securityDetails={{
        totalLoan: currency(TotalLoanAmount || 0, {
          precision: 0,
        }).format(),
        deposit: `${hasNegativeDeposit ? "-" : ""} ${currency(
          hasNegativeDeposit ? DepositAmount * -1 : DepositAmount,
          { precision: 0 },
        ).format()}`,
        lvr: `${LVR}%`,
      }}
    />
  );
};

export default SecurityDetails;
